import dayjs from "dayjs";
import { Helmet } from "react-helmet";
import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
  useLocation,
} from "react-router-dom";
import CustomSideBar from "./components/CustomSideBar.js";
import MaintenancePage from "./components/MaintenancePage.js";

const LoginPage = lazy(() => import("./pages/auth/login"));
const Signup = lazy(() => import("./pages/auth/signup"));
const NotAuth = lazy(() => import("./pages/NotAuth/NotAuth"));
const Paymentsv5 = lazy(() => import("./pages/paymentsV5/indexV2"));
const ProfitabilityV5 = lazy(() => import("./pages/profitv5/indexV4.js"));
const ProfitTableNew = lazy(() => import("./pages/profitTable/index.js"));
const SkuProfitability = lazy(() => import("./pages/SkuProfitability/indexV4.js"));
const ProfitabilityTest = lazy(() => import("./pages/profitNewTest/indexV4.js"));


const InvoiceTable = lazy(() =>
  import("./pages/Invoice/InvoiceTable/index.js")
);
const ReviewsV6 = lazy(() => import("./pages/ReviewV6/index"));
const AllExport = lazy(() => import("./pages/ModuleExport"));
const CustomerDetails = lazy(() =>
  import("./pages/AdminDashboard/adminDashboard.js")
);
const LLMPricing = lazy(() => import("./pages/AdminDashboard/LLMPricing.js"));
const AccountSettings = lazy(() => import("./userSettings/UserSettings.js"));
const ForgotPassword = lazy(() => import("./pages/auth/forgot"));
const Otp = lazy(() => import("./pages/auth/otp"));
const ChangePassword = lazy(() => import("./pages/auth/changePassword"));
const CreateCampaign = lazy(() =>
  import("./pages/ReviewV6/Campaigns/CreateCampaign")
);
const EditCampaign = lazy(() =>
  import("./pages/ReviewV6/Campaigns/EditCampaign")
);
const PageNotFound = lazy(() => import("./pages/PageNotFound/pageNotFound"));
const BuyboxSummary = lazy(() => import("./pages/BuyboxSummary/index"));
const MasterSKU = lazy(() => import("./pages/MasterSku"));
const PriceTracker = lazy(() => import("./pages/PriceTracker/index"));
const InventoryNew = lazy(() => import("./pages/InventoryV2/index"));
const Cashback = lazy(() => import("./pages/profitCashback"));
const OtherExpenses = lazy(() => import("./pages/otherExpenses"));
const PriceTrackerNew = lazy(() => import("./pages/PriceTrackerNew/index"));
const OutstandingPayments = lazy(() =>
  import("./pages/outstandingPayments/index.js")
);
const ExceptionRulesV2 = lazy(() =>
  import("./pages/ExceptionRulesV2/index.js")
);

const AddExceptionRules = lazy(() =>
  import("./pages/AddingExceptionRules/index.js")
);
const MobileFlipkartClaims= lazy(() => import("./pages/MobileFlipkartClaims/index.js"));
const Habanaro = lazy(() => import("./pages/habanaro/index.js"));
const UploadFileStatus = lazy(() => import("./pages/UploadStatus/index.js"));
const ProfitMonth = lazy(() => import("./pages/ProfitMonthToDay/index.js"));
const Claims = lazy(() => import("./pages/Claims"));
const ManualClaims = lazy(() => import("./pages/ManualClaims"));

const ProfitMonthlyComparison = lazy(() =>
  import("./pages/ProfitMonthComparison/index.js")
);
const BuyboxMultiplePincode = lazy(() =>
  import("./pages/BuyboxMultiplePincode/index.js")
);
const ProductCostInputIndex = lazy(() =>
  import("./pages/ProductCostInput/index.js")
);
const ProfitDoDAnalysis = lazy(() =>
  import("./pages/Profit DoD Analysis/index.js")
);
const AmazonVCPRecon = lazy(() => import("./pages/AmazonVCPRecon/index.js"));
const AmazonStarComparison = lazy(() =>
  import("./pages/AmazonStarPercentComparison/index.js")
);
const MultichannelDashboard = lazy(() =>
  import("./pages/MultipleChannelDashboard/index.js")
);
const MultipleChannelConnection = lazy(() =>
  import("./pages/MultipleChannelConnection/index.js")
);

const FeeWaiverConfig = lazy(() => import("./pages/FeesWaiverConfig/index.js"));
const FeesWaiverRecon = lazy(() => import("./pages/FeesWaiverRecon/index.js"));
const CustomOrdersReport = lazy(() =>
  import("./pages/CustomOrdersReport/index.js")
);

const SettledAmountConfig = lazy(() =>
  import("./pages/SettledAmountConfig/index.js")
);
const SettledAmountRecon = lazy(() =>
  import("./pages/SettledAmountRecon/index.js")
);

const CashbackDiscrepancy = lazy(() => import("./pages/CashbackDiscrepancy"));
const ReturnsTracker = lazy(() => import("./pages/ReturnsTracker/index.js"));
const ReturnConfig = lazy(() => import("./pages/ReturnsConfig/index.js"));
const ReturnSummary = lazy(() => import("./pages/Return Summary/index.js"));
const ClaimSummary = lazy(() => import("./pages/Claims Summary/index.js"));
const PoinvoiceRec = lazy(() => import("./pages/PoInvoiceRec/index.js"));
const QuickCommerceInventory = lazy(() =>
  import("./pages/QuickCommerceInventory/index.js")
);
const QuickCommercePayments = lazy(() =>
  import("./pages/QuickCommercePayments/index.js")
);
const QuickCommerceChannel = lazy(() =>
  import("./pages/QuickCommerceChannelProfit/index.js")
);
const QuickCommerceLedger = lazy(() =>
  import("./pages/QuickCommerceLedger/index.js")
);

const ClaimsRNROrders = lazy(() => import("./pages/ClaimsRNROrders/index.js"));
const InvoicePO = lazy(() => import("./pages/InvoicePo/index.js"));
const StdCostByStock = lazy(() =>
  import("./pages/StdCostInputByStock/index.js")
);
const LLMChat = lazy(() => import("./pages/LLMModal/components/ui/AppRouter.js"));
const Dashboard = lazy(() => import("./pages/Dashboard/index.js"));
const DashboardLive = lazy(() => import("./pages/DashboardLive/index.js"));


const ProductMasterSku = lazy(() => import("./pages/ProductMasterSku/index.js"));
const FinanceMasterSku = lazy(() => import("./pages/FinanceMastersku/index.js"));
const OverviewProductConfigure = lazy(() => import("./pages/OverviewProductConfigure/index.js"));
const SkuProfitDoDAnalysis = lazy(() =>  import("./pages/SkuProfitDoDAnalysis/index.js"));
const SkuProfitMonth = lazy(() => import("./pages/SkuProfitMonthToDay/index.js"));
const ProfitSummary = lazy(() => import("./pages/Profitability/ProfitSummary/index.js"));
const LandingPage = lazy(() => import("./pages/LandingPage/index.js"));
const BankTransfer = lazy(() => import("./pages/Payments/BankTransfer/index.js"));
const PaymentsOutstanding = lazy(() => import("./pages/Payments/Outstandingpayments/index.js"));
const PaymentsD2C = lazy(() => import("./pages/Payments/D2C/index.js"));
const PaymentsB2C = lazy(() => import("./pages/Payments/B2C/index.js"));
const ActionRequiredRules = lazy(() => import("./pages/ActionRequiredRules/index.js"));








const AuthRoute = () => {
  const location = useLocation();
  
  if (!localStorage.getItem("token")) return <Navigate to="/login" />;

  if (!userPermissions()) return <Navigate to="/not-auth" />;

  // If subscription is expired, allow access to account-settings pages, redirect others
  if (renewplanFunction()) {
    // Allow access to account-settings pages when subscription is expired
    if (location.pathname.startsWith("/account-settings")) {
      return <Outlet />;
    }
    // Redirect other routes to account settings
    return <Navigate to="/account-settings/account" />;
  }

  return <Outlet />;
};

const userPermissions = () => {
  let dataArray = JSON.parse(localStorage.getItem("userPermission"));
  let baseRoutes = [
    "ADMINDASHBOARD_READ",
    "PROFITABILITY_READ",
    "SYNCDETAILS_READ",
    "DASHBOARD_READ",
    "PAYMENTTRACKER_READ",
    "SALESDEFENCE_READ",
    "INVENTORY_READ",
    "MASTERSKUMAPPING_READ",
    "STORAGELOCATIONS_READ",
    "ORDERSTRACKER_READ",
    "REVIEWS_READ",
    "PRODUCTCONFIG_READ",
    "ACCOUNTSETTINGS_READ",
    "RETURNSTRACKER_READ",
    "DOWNLOADS_READ",
    "ACTIONREQUIRED_READ",
    "OPTIMIZECASH_READ",
    "PROFITLOSSCOMPARISON_READ",
    "PROFITLOSSMONTHLY_READ",
    "OUTSTANDINGPAYMENTS_READ",
    "SETTLEDAMOUNTRECON_READ",
  ];
  
  // Map routes to their permission groups
  const profitabilityRoutes = [
    "/profit-analysis",
    "/profit-loss-monthly",
    "/dashboard",
    "/custom-dashboard",
  ];
  
  const paymentTrackerRoutes = [
    "/outstanding-payments",
    "/invoice-po",
    "/amazonvcp-recon",
    "/quickcommerce-payments",
    "/po-rec-others",
    "/quickcommerce-ledger",
    "/fee-waiver-recon",
    "/settled-amount-recon",
    // "/returns-summary",
    // "/returns-tracker",
    // "/returns-config",
    // "/claims-summary",
    // "/claims",
  ];
  
  let pathName = (
    window.location.pathname.replace(/[^\w\s]|[\d]/gi, "") + "_read"
  ).toUpperCase();

  // Check if route belongs to profitability group
  const isProfitabilityRoute = profitabilityRoutes.some(route => 
    window.location.pathname.startsWith(route)
  );
  if (isProfitabilityRoute) {
    return dataArray.includes("PROFITABILITY_READ");
  }
  
  // Check if route belongs to payment tracker group
  const isPaymentTrackerRoute = paymentTrackerRoutes.some(route => 
    window.location.pathname.startsWith(route)
  );
  if (isPaymentTrackerRoute) {
    return dataArray.includes("PAYMENTTRACKER_READ");
  }
  
  // only for account settings----------------------
  let pathSegments = window.location.pathname.split("/");
  let filteredSegment = pathSegments.filter(
    (segment) => segment === "account-settings"
  )[0];
  let accountpathName = filteredSegment
    ? filteredSegment.replace(/[^\w\s]|[\d]/gi, "").toUpperCase() + "_READ"
    : "";
  // ----------------------------------------------------------------------------
  for (let baseRoute of baseRoutes) {
    if (pathName.startsWith(baseRoute) && dataArray.includes(baseRoute)) {
      return true;
    }
    if (
      accountpathName.startsWith(baseRoute) &&
      dataArray.includes(baseRoute)
    ) {
      return true;
    }
    // if (pathName === baseRoute && dataArray.includes("PAYMENTTRACKER_READ")) {
    //   return true;
    // }
  }
};

const renewplanFunction = () => {
  const days = localStorage.getItem("subscriptionDays");
  const start = new Date();
  const end = dayjs(days, "YYYY-MM-DD");
  const subscriptiondays = Math.round((end - start) / 1000 / 60 / 60 / 24) + 2;
  return subscriptiondays <= 0;
};

const renderRoutes = (path, component) => (
  <Route element={<AuthRoute />}>
    <Route path={path} element={component} />
  </Route>
);
const createRoute = (path, element) => <Route path={path} element={element} />;
const WithCustomSideBar = ({ children }) => (
  <CustomSideBar>{children}</CustomSideBar>
);

const RoutesPage = (props) => {
  const userEmail = JSON.parse(localStorage.getItem("user_info")) || {};

  const isUnderMaintenance = false; // true for under maintenance
  if (isUnderMaintenance) {
    return <MaintenancePage />;
  }

  return (
    <Router {...props}>
      <Suspense
        fallback={
          <>
            <Helmet>
              <title>{"Forcesight"}</title>
            </Helmet>
            <CustomSideBar></CustomSideBar>
          </>
        }
      >
        {/* Auth Route   */}

        {/* Excluded Customsidebar */}
        <Routes>
          {renderRoutes("/admin-dashboard", <CustomerDetails />)}
          {createRoute("/llm-pricing", <LLMPricing />)}
          {createRoute("/", <LoginPage />)}
          {createRoute("/login", <LoginPage />)}
          {createRoute("/landing", <LandingPage />)}
          {createRoute("/register", <Signup />)}
          {createRoute("/forgot-password", <ForgotPassword />)}
          {createRoute("/enter-otp", <Otp {...props} />)}
          {createRoute("/change-password", <ChangePassword {...props} />)}
          {createRoute("/*", <PageNotFound />)}
          {createRoute(
            "/not-auth",
            <WithCustomSideBar>
              <NotAuth />
            </WithCustomSideBar>
          )}
          {createRoute("/create-campaigns", <CreateCampaign />)}
          {createRoute("/edit-campaigns/:id", <EditCampaign />)}

          {renderRoutes(
            "/payment-tracker/:tabIndex",
            <WithCustomSideBar>
              <Paymentsv5 />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/order-profitability/:tabIndex",
            <WithCustomSideBar>
              <ProfitabilityV5 />
            </WithCustomSideBar>
          )}
          {/* sku profitability */}
           {renderRoutes(
            "/profitability/:tabIndex",
            <WithCustomSideBar>
              <SkuProfitability />
            </WithCustomSideBar>
          )}
          {/* testing */}
          {createRoute(
            "/profitabilitytest/:tabIndex",
            <WithCustomSideBar>
              <ProfitabilityTest />
            </WithCustomSideBar>
          )}
         
          
          {/* -------------------------- */}
          {renderRoutes(
            "/reviews/:tabIndex",
            <WithCustomSideBar>
              <ReviewsV6 />
            </WithCustomSideBar>
          )}
          {renderRoutes(
            "/sales-defence/:tabIndex",
            <WithCustomSideBar>
              <BuyboxSummary />
            </WithCustomSideBar>
          )}
          {renderRoutes(
            "/downloads",
            <WithCustomSideBar>
              <AllExport />
            </WithCustomSideBar>
          )}
          {renderRoutes(
            "/inventory/:tabIndex",
            <WithCustomSideBar>
              <InventoryNew />
            </WithCustomSideBar>
          )}

          {/* ---------------------------------- */}

          {renderRoutes(
            "/account-settings/*",
            <WithCustomSideBar>
              <AccountSettings />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/price-tracker/:tabIndex",
            <WithCustomSideBar>
              {" "}
              <PriceTracker />
            </WithCustomSideBar>
          )}

          {createRoute(
            "/buybox-summary",
            <WithCustomSideBar>
              <BuyboxSummary />
            </WithCustomSideBar>
          )}
          {renderRoutes(
            "/productconfig/:tabIndex",
            <WithCustomSideBar>
              <MasterSKU />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/cashback",
            <WithCustomSideBar>
              <Cashback />
            </WithCustomSideBar>
          )}

          {createRoute(
            "/other-expenses",
            <WithCustomSideBar>
              <OtherExpenses />
            </WithCustomSideBar>
          )}

          {renderRoutes(
            "/action-required",
            <WithCustomSideBar>
              {" "}
              <ExceptionRulesV2 />
            </WithCustomSideBar>
          )}

          {createRoute(
            "/invoice-table",
            <WithCustomSideBar>
              <InvoiceTable />
            </WithCustomSideBar>
          )}

          {/* {createRoute(
            "/PricetrackerV2",
            <WithCustomSideBar>
              <PriceTrackerNew />
            </WithCustomSideBar>
          )} */}
          {renderRoutes(
            "/outstanding-payments",
            <WithCustomSideBar>
              <OutstandingPayments />
            </WithCustomSideBar>
          )}
          {/* {renderRoutes("/exception-rules",<WithCustomSideBar><ExceptionRulesV2 /></WithCustomSideBar> )} */}
          {/* {createRoute("/exception-rules-v2", <WithCustomSideBar><ExceptionRulesV2 /></WithCustomSideBar>)} */}

          {createRoute(
            "/add-exception-rules",
            <WithCustomSideBar>
              {" "}
              <AddExceptionRules />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/habaneo",
            <WithCustomSideBar>
              <Habanaro />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/mobile-claim-details",
            <WithCustomSideBar>
              <MobileFlipkartClaims />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/upload-file-status",
            <WithCustomSideBar>
              <UploadFileStatus />
            </WithCustomSideBar>
          )}
          {renderRoutes(
            "/profit-loss-monthly",
            <WithCustomSideBar>
             <SkuProfitMonth />
              {/* <ProfitMonth /> */}
            </WithCustomSideBar>
          )}
            {/* testing */}
           {/* {createRoute(
            "/sku-profit-loss-monthly",
            <WithCustomSideBar>
              <SkuProfitMonth />
            </WithCustomSideBar>
          )} */}
         
          {createRoute(
            "/claims",
            <WithCustomSideBar>
              <Claims />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/manual_claims",
            <WithCustomSideBar>
              <ManualClaims />
            </WithCustomSideBar>
          )}
          {renderRoutes(
            "/profit-loss-comparison",
            <WithCustomSideBar>
              <ProfitMonthlyComparison />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/buybox-multiple-pincode",
            <WithCustomSideBar>
              <BuyboxMultiplePincode />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/inputcost",
            <WithCustomSideBar>
              <ProductCostInputIndex />
            </WithCustomSideBar>
          )}
          {renderRoutes(
            "/profit-analysis",
            <WithCustomSideBar>
               <SkuProfitDoDAnalysis />
              {/* <ProfitDoDAnalysis /> */}
            </WithCustomSideBar>
          )}
          {/* {createRoute(
            "/sku-profit-analysis",
            <WithCustomSideBar>
              <SkuProfitDoDAnalysis />
            </WithCustomSideBar>
          )} */}
          {createRoute(
            "/amazonvcp-recon",
            <WithCustomSideBar>
              <AmazonVCPRecon />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/amazon-india-star-comparison",
            <WithCustomSideBar>
              <AmazonStarComparison />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/marketplace-settings-dashboard",
            <WithCustomSideBar>
              <MultichannelDashboard />
            </WithCustomSideBar>
          )}
          {createRoute(
            // "/account-settings/marketplace",
            "/marketplace-settings-connection",
            <WithCustomSideBar>
              <MultipleChannelConnection />
            </WithCustomSideBar>
          )} 
          {createRoute(
            // "/account-settings/marketplace/:channelId",
            "/marketplace-settings-connection/:channelId",
            <WithCustomSideBar>
              <MultipleChannelConnection />
            </WithCustomSideBar>
          )}

          {createRoute(
            "/fee-waiver-config",
            <WithCustomSideBar>
              <FeeWaiverConfig />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/fee-waiver-recon",
            <WithCustomSideBar>
              <FeesWaiverRecon />
            </WithCustomSideBar>
          )}
          {/* {createRoute(
            "/custom-orders-report",
            <WithCustomSideBar>
              <CustomOrdersReport />
            </WithCustomSideBar>
          )} */}
          
          {createRoute(
            "/settled-amount-config",
            <WithCustomSideBar>
              <SettledAmountConfig />
            </WithCustomSideBar>
          )}
          {renderRoutes(
            "/settled-amount-recon",
            <WithCustomSideBar>
              <SettledAmountRecon />
            </WithCustomSideBar>
          )}

          {createRoute(
            "/cashback-discrepancy",
            <WithCustomSideBar>
              <CashbackDiscrepancy />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/returns-tracker",
            <WithCustomSideBar>
              <ReturnsTracker />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/returns-config",
            <WithCustomSideBar>
              <ReturnConfig />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/returns-summary",
            <WithCustomSideBar>
              <ReturnSummary />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/claims-summary",
            <WithCustomSideBar>
              <ClaimSummary />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/po-rec-others",
            <WithCustomSideBar>
              <PoinvoiceRec />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/quickcommerce-inventory",
            <WithCustomSideBar>
              <QuickCommerceInventory />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/quickcommerce-payments",
            <WithCustomSideBar>
              <QuickCommercePayments />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/quickcommerce-channel-profit",
            <WithCustomSideBar>
              <QuickCommerceChannel />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/quickcommerce-ledger",
            <WithCustomSideBar>
              <QuickCommerceLedger />
            </WithCustomSideBar>
          )}

          {createRoute(
            "/claims-rnr-orders",
            <WithCustomSideBar>
              <ClaimsRNROrders />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/std-cost-input",
            <WithCustomSideBar>
              <StdCostByStock />
            </WithCustomSideBar>
          )}
          {/* {createRoute(
            "/payment-trackerv5/:tabIndex",
            <WithCustomSideBar>
              <Paymentsv5 />
            </WithCustomSideBar>
          )} */}
          {createRoute(
            "/invoice-po",
            <WithCustomSideBar>
              <InvoicePO />
            </WithCustomSideBar>
          )}

          {createRoute("/helix-ai",  <WithCustomSideBar><LLMChat /></WithCustomSideBar>)}
          {renderRoutes(
            "/dashboard",
            <WithCustomSideBar>
              <Dashboard />
              {/* <DashboardLive /> */}
            </WithCustomSideBar>
          )}
          
          {createRoute(
            "/product-configuration",
            <WithCustomSideBar>
              <ProductMasterSku />
            </WithCustomSideBar>
          )
          }
          {createRoute(
            "/finance-configuration",
            <WithCustomSideBar>
              <FinanceMasterSku />
            </WithCustomSideBar>
          )
          }
          {createRoute(
            "/overview-settings",
            <WithCustomSideBar>
              <OverviewProductConfigure />
            </WithCustomSideBar>
          )
          }
           {createRoute(
            "/profit-summary",
            <WithCustomSideBar>
              <ProfitSummary />
            </WithCustomSideBar>
          )}
            {createRoute(
            "/profit-table-view",
            <WithCustomSideBar>
              <ProfitTableNew />
            </WithCustomSideBar>
          )}
           {createRoute(
            "/payments-bank-transfer",
            <WithCustomSideBar>
              <BankTransfer />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/payments-outstanding",
            <WithCustomSideBar>
              <PaymentsOutstanding />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/payments-d2c",
            <WithCustomSideBar>
              <PaymentsD2C />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/payments-b2c",
            <WithCustomSideBar>
              <PaymentsB2C />
            </WithCustomSideBar>
          )}
          {createRoute(
            "/action-rules",
            <WithCustomSideBar>
              <ActionRequiredRules />
            </WithCustomSideBar>
          )}
        </Routes>
      </Suspense>
    </Router>
  );
};
export default RoutesPage;
